module.exports = __webpack_public_path__ + "img/single-neutral-actions-check.27a16f4f.svg";